export const visit = (vm, at) => {
at({ "he-il": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "\u05D4\u05D5\u05D3\u05E2\u05D4 \u05D7\u05D3\u05E9\u05D4" } } } });
};